
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://a8106052357b4da4992b948ebcb77b77@sentry.haltu.net/38',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
